import { AnySeries, seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveTime, TimeSeriesChartDataItem } from './TimeSeriesChartData';

export const line = <T extends TimeSeriesChartDataItem>(
    mainValue: (d: T) => number | undefined,
    className: string,
    crossValue: (d: T) => number | undefined = deriveTime
): AnySeries =>
    seriesSvgLine()
        .crossValue(crossValue)
        .mainValue(mainValue)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .decorate((selection: any) => {
            selection.classed(className, true);
        });
